/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateBulkMetricValuesDto,
  CreateMetricValueDto,
  CreateWearablePermissionAuditLogDto,
  ErrorResponse,
  MetricValueLatestRequestDto,
  MetricValueResponseDto,
  MetricValuesAggregationRequestDto,
  MetricValuesAggregationResponseDto,
  MetricValuesPaginationRequestDto,
  MetricValuesPaginationResponseDto,
  UpdateMetricValueDto,
} from '../models/index';
import {
    CreateBulkMetricValuesDtoFromJSON,
    CreateBulkMetricValuesDtoToJSON,
    CreateMetricValueDtoFromJSON,
    CreateMetricValueDtoToJSON,
    CreateWearablePermissionAuditLogDtoFromJSON,
    CreateWearablePermissionAuditLogDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    MetricValueLatestRequestDtoFromJSON,
    MetricValueLatestRequestDtoToJSON,
    MetricValueResponseDtoFromJSON,
    MetricValueResponseDtoToJSON,
    MetricValuesAggregationRequestDtoFromJSON,
    MetricValuesAggregationRequestDtoToJSON,
    MetricValuesAggregationResponseDtoFromJSON,
    MetricValuesAggregationResponseDtoToJSON,
    MetricValuesPaginationRequestDtoFromJSON,
    MetricValuesPaginationRequestDtoToJSON,
    MetricValuesPaginationResponseDtoFromJSON,
    MetricValuesPaginationResponseDtoToJSON,
    UpdateMetricValueDtoFromJSON,
    UpdateMetricValueDtoToJSON,
} from '../models/index';

export interface CreateBulkMetricValuesRequest {
    createBulkMetricValuesDto: CreateBulkMetricValuesDto;
}

export interface CreateBulkMetricValuesByPatientIdRequest {
    patientId: string;
    createBulkMetricValuesDto: CreateBulkMetricValuesDto;
}

export interface CreateMetricValueRequest {
    createMetricValueDto: CreateMetricValueDto;
}

export interface CreateMetricValueByPatientIdRequest {
    patientId: string;
    createMetricValueDto: CreateMetricValueDto;
}

export interface CreateWearablePermissionAuditLogRequest {
    createWearablePermissionAuditLogDto: CreateWearablePermissionAuditLogDto;
}

export interface DeleteMetricValueRequest {
    id: number;
}

export interface DeleteMetricValueByPatientIdRequest {
    patientId: string;
    id: number;
}

export interface GetLatestMetricValueRequest {
    metricValueLatestRequestDto: MetricValueLatestRequestDto;
}

export interface GetLatestMetricValueByPatientIdRequest {
    patientId: string;
    metricValueLatestRequestDto: MetricValueLatestRequestDto;
}

export interface GetMetricValuesAggregatedRequest {
    metricValuesAggregationRequestDto: MetricValuesAggregationRequestDto;
}

export interface GetMetricValuesAggregatedByPatientIdRequest {
    patientId: string;
    metricValuesAggregationRequestDto: MetricValuesAggregationRequestDto;
}

export interface GetMetricValuesPaginatedRequest {
    metricValuesPaginationRequestDto: MetricValuesPaginationRequestDto;
    page?: number;
    pageSize?: number;
}

export interface GetMetricValuesPaginatedByPatientIdRequest {
    patientId: string;
    metricValuesPaginationRequestDto: MetricValuesPaginationRequestDto;
    page?: number;
    pageSize?: number;
}

export interface UpdateMetricValueByPatientIdRequest {
    patientId: string;
    id: number;
    updateMetricValueDto: UpdateMetricValueDto;
}

/**
 * 
 */
export class ActivityApi extends runtime.BaseAPI {

    /**
     * Create multiple activity metric values for a patient in a single request with validation
     * Create Bulk Activity Metric Values
     */
    async createBulkMetricValuesRaw(requestParameters: CreateBulkMetricValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['createBulkMetricValuesDto'] == null) {
            throw new runtime.RequiredError(
                'createBulkMetricValuesDto',
                'Required parameter "createBulkMetricValuesDto" was null or undefined when calling createBulkMetricValues().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/activity/metric-values/bulk`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateBulkMetricValuesDtoToJSON(requestParameters['createBulkMetricValuesDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create multiple activity metric values for a patient in a single request with validation
     * Create Bulk Activity Metric Values
     */
    async createBulkMetricValues(requestParameters: CreateBulkMetricValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createBulkMetricValuesRaw(requestParameters, initOverrides);
    }

    /**
     * Create multiple activity metric values for a patient by patient ID in a single request with validation
     * Create Bulk Activity Metric Values by Patient ID
     */
    async createBulkMetricValuesByPatientIdRaw(requestParameters: CreateBulkMetricValuesByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling createBulkMetricValuesByPatientId().'
            );
        }

        if (requestParameters['createBulkMetricValuesDto'] == null) {
            throw new runtime.RequiredError(
                'createBulkMetricValuesDto',
                'Required parameter "createBulkMetricValuesDto" was null or undefined when calling createBulkMetricValuesByPatientId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/activity/metric-values/bulk/patients/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateBulkMetricValuesDtoToJSON(requestParameters['createBulkMetricValuesDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create multiple activity metric values for a patient by patient ID in a single request with validation
     * Create Bulk Activity Metric Values by Patient ID
     */
    async createBulkMetricValuesByPatientId(requestParameters: CreateBulkMetricValuesByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createBulkMetricValuesByPatientIdRaw(requestParameters, initOverrides);
    }

    /**
     * Create a single activity metric value for a patient with validation
     * Create Activity Metric Value
     */
    async createMetricValueRaw(requestParameters: CreateMetricValueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['createMetricValueDto'] == null) {
            throw new runtime.RequiredError(
                'createMetricValueDto',
                'Required parameter "createMetricValueDto" was null or undefined when calling createMetricValue().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/activity/metric-values`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateMetricValueDtoToJSON(requestParameters['createMetricValueDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create a single activity metric value for a patient with validation
     * Create Activity Metric Value
     */
    async createMetricValue(requestParameters: CreateMetricValueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createMetricValueRaw(requestParameters, initOverrides);
    }

    /**
     * Create a single activity metric value for a patient by patient ID with validation
     * Create Activity Metric Value by Patient ID
     */
    async createMetricValueByPatientIdRaw(requestParameters: CreateMetricValueByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling createMetricValueByPatientId().'
            );
        }

        if (requestParameters['createMetricValueDto'] == null) {
            throw new runtime.RequiredError(
                'createMetricValueDto',
                'Required parameter "createMetricValueDto" was null or undefined when calling createMetricValueByPatientId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/activity/metric-values/patients/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateMetricValueDtoToJSON(requestParameters['createMetricValueDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create a single activity metric value for a patient by patient ID with validation
     * Create Activity Metric Value by Patient ID
     */
    async createMetricValueByPatientId(requestParameters: CreateMetricValueByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createMetricValueByPatientIdRaw(requestParameters, initOverrides);
    }

    /**
     * Create an audit log when a patient toggles wearable sync or completes wearable permission checks
     * Create Wearable Permission Audit Log
     */
    async createWearablePermissionAuditLogRaw(requestParameters: CreateWearablePermissionAuditLogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['createWearablePermissionAuditLogDto'] == null) {
            throw new runtime.RequiredError(
                'createWearablePermissionAuditLogDto',
                'Required parameter "createWearablePermissionAuditLogDto" was null or undefined when calling createWearablePermissionAuditLog().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/activity/wearable-permission-audit-logs`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateWearablePermissionAuditLogDtoToJSON(requestParameters['createWearablePermissionAuditLogDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create an audit log when a patient toggles wearable sync or completes wearable permission checks
     * Create Wearable Permission Audit Log
     */
    async createWearablePermissionAuditLog(requestParameters: CreateWearablePermissionAuditLogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createWearablePermissionAuditLogRaw(requestParameters, initOverrides);
    }

    /**
     * Soft delete an activity metric value for a patient (marks as deleted but preserves data)
     * Soft Delete Activity Metric Value
     */
    async deleteMetricValueRaw(requestParameters: DeleteMetricValueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteMetricValue().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/activity/metric-values/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Soft delete an activity metric value for a patient (marks as deleted but preserves data)
     * Soft Delete Activity Metric Value
     */
    async deleteMetricValue(requestParameters: DeleteMetricValueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteMetricValueRaw(requestParameters, initOverrides);
    }

    /**
     * Soft delete an activity metric value for a patient by patient ID (marks as deleted but preserves data)
     * Soft Delete Activity Metric Value by Patient ID
     */
    async deleteMetricValueByPatientIdRaw(requestParameters: DeleteMetricValueByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling deleteMetricValueByPatientId().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteMetricValueByPatientId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/activity/metric-values/patients/{patientId}/{id}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Soft delete an activity metric value for a patient by patient ID (marks as deleted but preserves data)
     * Soft Delete Activity Metric Value by Patient ID
     */
    async deleteMetricValueByPatientId(requestParameters: DeleteMetricValueByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteMetricValueByPatientIdRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieve the latest daily activity metric value for a patient. The response is the most recent record, but for numeric metrics its valueInt/valueFloat is the total (sum) of all records on that most recent day. Optional filtering by health provider and date range. Returns null when no matching record exists.
     * Get Latest Daily Activity Metric Value
     */
    async getLatestMetricValueRaw(requestParameters: GetLatestMetricValueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MetricValueResponseDto>> {
        if (requestParameters['metricValueLatestRequestDto'] == null) {
            throw new runtime.RequiredError(
                'metricValueLatestRequestDto',
                'Required parameter "metricValueLatestRequestDto" was null or undefined when calling getLatestMetricValue().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/activity/metric-values/query/latest`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MetricValueLatestRequestDtoToJSON(requestParameters['metricValueLatestRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MetricValueResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve the latest daily activity metric value for a patient. The response is the most recent record, but for numeric metrics its valueInt/valueFloat is the total (sum) of all records on that most recent day. Optional filtering by health provider and date range. Returns null when no matching record exists.
     * Get Latest Daily Activity Metric Value
     */
    async getLatestMetricValue(requestParameters: GetLatestMetricValueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MetricValueResponseDto> {
        const response = await this.getLatestMetricValueRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve the latest daily activity metric value for a specific patient by patient ID. The response is the most recent record, but for numeric metrics its valueInt/valueFloat is the total (sum) of all records on that most recent day. Optional filtering by health provider and date range. Returns null when no matching record exists.
     * Get Latest Daily Activity Metric Value by Patient ID
     */
    async getLatestMetricValueByPatientIdRaw(requestParameters: GetLatestMetricValueByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MetricValueResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getLatestMetricValueByPatientId().'
            );
        }

        if (requestParameters['metricValueLatestRequestDto'] == null) {
            throw new runtime.RequiredError(
                'metricValueLatestRequestDto',
                'Required parameter "metricValueLatestRequestDto" was null or undefined when calling getLatestMetricValueByPatientId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/activity/metric-values/query/latest/patients/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MetricValueLatestRequestDtoToJSON(requestParameters['metricValueLatestRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MetricValueResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve the latest daily activity metric value for a specific patient by patient ID. The response is the most recent record, but for numeric metrics its valueInt/valueFloat is the total (sum) of all records on that most recent day. Optional filtering by health provider and date range. Returns null when no matching record exists.
     * Get Latest Daily Activity Metric Value by Patient ID
     */
    async getLatestMetricValueByPatientId(requestParameters: GetLatestMetricValueByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MetricValueResponseDto> {
        const response = await this.getLatestMetricValueByPatientIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve aggregated activity metric values for a patient grouped by time interval with optional filtering by date range, metric, and health provider
     * Get Activity Metric Values (Aggregated)
     */
    async getMetricValuesAggregatedRaw(requestParameters: GetMetricValuesAggregatedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MetricValuesAggregationResponseDto>> {
        if (requestParameters['metricValuesAggregationRequestDto'] == null) {
            throw new runtime.RequiredError(
                'metricValuesAggregationRequestDto',
                'Required parameter "metricValuesAggregationRequestDto" was null or undefined when calling getMetricValuesAggregated().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/activity/metric-values/query/aggregated`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MetricValuesAggregationRequestDtoToJSON(requestParameters['metricValuesAggregationRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MetricValuesAggregationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve aggregated activity metric values for a patient grouped by time interval with optional filtering by date range, metric, and health provider
     * Get Activity Metric Values (Aggregated)
     */
    async getMetricValuesAggregated(requestParameters: GetMetricValuesAggregatedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MetricValuesAggregationResponseDto> {
        const response = await this.getMetricValuesAggregatedRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve aggregated activity metric values for a specific patient by patient ID grouped by time interval with optional filtering by date range, metric, and health provider
     * Get Activity Metric Values by Patient ID (Aggregated)
     */
    async getMetricValuesAggregatedByPatientIdRaw(requestParameters: GetMetricValuesAggregatedByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MetricValuesAggregationResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getMetricValuesAggregatedByPatientId().'
            );
        }

        if (requestParameters['metricValuesAggregationRequestDto'] == null) {
            throw new runtime.RequiredError(
                'metricValuesAggregationRequestDto',
                'Required parameter "metricValuesAggregationRequestDto" was null or undefined when calling getMetricValuesAggregatedByPatientId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/activity/metric-values/query/aggregated/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MetricValuesAggregationRequestDtoToJSON(requestParameters['metricValuesAggregationRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MetricValuesAggregationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve aggregated activity metric values for a specific patient by patient ID grouped by time interval with optional filtering by date range, metric, and health provider
     * Get Activity Metric Values by Patient ID (Aggregated)
     */
    async getMetricValuesAggregatedByPatientId(requestParameters: GetMetricValuesAggregatedByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MetricValuesAggregationResponseDto> {
        const response = await this.getMetricValuesAggregatedByPatientIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve paginated list of activity metric values for a patient with optional filtering by date range, metric, and health provider
     * Get Activity Metric Values (Paginated)
     */
    async getMetricValuesPaginatedRaw(requestParameters: GetMetricValuesPaginatedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MetricValuesPaginationResponseDto>> {
        if (requestParameters['metricValuesPaginationRequestDto'] == null) {
            throw new runtime.RequiredError(
                'metricValuesPaginationRequestDto',
                'Required parameter "metricValuesPaginationRequestDto" was null or undefined when calling getMetricValuesPaginated().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/activity/metric-values/query/paginated`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MetricValuesPaginationRequestDtoToJSON(requestParameters['metricValuesPaginationRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MetricValuesPaginationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve paginated list of activity metric values for a patient with optional filtering by date range, metric, and health provider
     * Get Activity Metric Values (Paginated)
     */
    async getMetricValuesPaginated(requestParameters: GetMetricValuesPaginatedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MetricValuesPaginationResponseDto> {
        const response = await this.getMetricValuesPaginatedRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve paginated list of activity metric values for a patient by patient ID with optional filtering by date range, metric, and health provider
     * Get Activity Metric Values by Patient ID (Paginated)
     */
    async getMetricValuesPaginatedByPatientIdRaw(requestParameters: GetMetricValuesPaginatedByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MetricValuesPaginationResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getMetricValuesPaginatedByPatientId().'
            );
        }

        if (requestParameters['metricValuesPaginationRequestDto'] == null) {
            throw new runtime.RequiredError(
                'metricValuesPaginationRequestDto',
                'Required parameter "metricValuesPaginationRequestDto" was null or undefined when calling getMetricValuesPaginatedByPatientId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/activity/metric-values/query/paginated/patients/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MetricValuesPaginationRequestDtoToJSON(requestParameters['metricValuesPaginationRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MetricValuesPaginationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve paginated list of activity metric values for a patient by patient ID with optional filtering by date range, metric, and health provider
     * Get Activity Metric Values by Patient ID (Paginated)
     */
    async getMetricValuesPaginatedByPatientId(requestParameters: GetMetricValuesPaginatedByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MetricValuesPaginationResponseDto> {
        const response = await this.getMetricValuesPaginatedByPatientIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an activity metric value for a patient by patient ID with validation
     * Update Activity Metric Value by Patient ID
     */
    async updateMetricValueByPatientIdRaw(requestParameters: UpdateMetricValueByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling updateMetricValueByPatientId().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateMetricValueByPatientId().'
            );
        }

        if (requestParameters['updateMetricValueDto'] == null) {
            throw new runtime.RequiredError(
                'updateMetricValueDto',
                'Required parameter "updateMetricValueDto" was null or undefined when calling updateMetricValueByPatientId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/activity/metric-values/patients/{patientId}/{id}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateMetricValueDtoToJSON(requestParameters['updateMetricValueDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update an activity metric value for a patient by patient ID with validation
     * Update Activity Metric Value by Patient ID
     */
    async updateMetricValueByPatientId(requestParameters: UpdateMetricValueByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateMetricValueByPatientIdRaw(requestParameters, initOverrides);
    }

}
